import { Injectable, inject } from '@angular/core';
import { map, type Observable } from 'rxjs';

import { HttpClientService } from './http-client.service';
import type { TimelineEventsClient } from '../tokens/timeline-events-client.token';
import type { TimelineEvent } from '../../features/variance-tracker/components/variance-supporting-data/models/timeline-event.model';
import { TIMELINE_EVENTS } from '../../shared/constants/api-routes.constants';

type TimelineEventDto = Omit<TimelineEvent, 'createdAt' | 'updatedAt'> & {
  readonly createdAt: string;
  readonly updatedAt?: string | null;
};

@Injectable({ providedIn: 'root' })
export class TimelineEventsService implements TimelineEventsClient {
  private readonly http = inject(HttpClientService);

  getTimelineEvents(caseId: number): Observable<readonly TimelineEvent[]> {
    return this.http.get<readonly TimelineEventDto[]>(TIMELINE_EVENTS.BY_CASE_ID(caseId)).pipe(
      map((events) =>
        events.map((e) => ({
          ...e,
          createdAt: new Date(e.createdAt),
          updatedAt: e.updatedAt ? new Date(e.updatedAt) : null,
        }))
      )
    );
  }
}

